import { createSlice } from '@reduxjs/toolkit'
import helper from '../../Helper';
import API from "../../APIS/index";

let frontUrl = helper.FrontBackendURL();

const initialState = {
    loading: false,
    betRes: [],
    currentBetRes: [],
    manualCashoutRes: [],
    autoBetRes: [],
    highRollersCrashRes: [],
    allUserCrashGameHistory: [],
    updatelossdata: [],
    rarewinsdata: [],
    singleUserGameHistory: [],
    gamestatusdata: [],
    error: "",
}

const crashSlice = createSlice({
    name: 'crashBet',
    initialState,
    reducers: {
        bet: (state, action) => {
            state.betRes = action.payload
        },
        currentBet: (state, action) => {
            state.currentBetRes = action.payload
        },
        manualCashout: (state, action) => {
            state.manualCashoutRes = action.payload
        },
        manualCashout: (state, action) => {
            state.manualCashoutRes = action.payload
        },
        autoCashout: (state, action) => {
            state.autoBetRes = action.payload
        },
        highRollerCrash: (state, action) => {
            state.highRollersCrashRes = action.payload
        },
        alluserGameHistory: (state, action) => {
            state.allUserCrashGameHistory = action.payload
        },
        singleuserGameHistory: (state, action) => {
            state.singleUserGameHistory = action.payload
        },
        lossdata: (state, action) => {
            state.updatelossdata = action.payload
        },
        rarewins: (state, action) => {
            state.rarewinsdata = action.payload
        },
        getgame: (state, action) => {
            state.gamestatusdata = action.payload
        }


    }
})

export const { bet, currentBet, manualCashout, alluserGameHistory, lossdata, singleuserGameHistory, highRollerCrash, autoCashout, rarewins, getgame } = crashSlice.actions;
export default crashSlice.reducer;

export const betCrash = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.CRASH_BET_API}`, data);
            callback(response)
            dispatch(bet(response?.data))
            return response?.data
        } catch (e) {
            return console.error(e.message)
        }
    }

export const Rarewinlist = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.RARE_WINS}`, data);
            callback(response)
            dispatch(rarewins(response?.data))
            return response?.data
        } catch (e) {
            return console.error(e.message)
        }
    }

export const getCrashCurrentbet = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.GET_CURRENT_CRASH_BET}`, data);
            callback(response)
            dispatch(currentBet(response?.data))
            return response?.data
        } catch (e) {
            return console.error(e.message)
        }
    }

export const getManualCashout = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.GET_MANUAL_CASHOUT_BET}`, data);
            callback(response)
            dispatch(manualCashout(response?.data))
            return response?.data
        } catch (e) {
            return console.error(e.message)
        }
    }

export const getAutoCashout = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.AUTO_CASHOUT_BET}`, data);
            callback(response)
            dispatch(autoCashout(response?.data))
            return response?.data
        } catch (e) {
            return console.error(e.message)
        }
    }

export const getCrashHighRollers = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.GET_HIGH_CRASH_ROLLERS}`, data);
            callback(response)
            dispatch(highRollerCrash(response?.data))
            return response?.data
        } catch (e) {
            return console.error(e.message)
        }
    }

export const getAllCrashGameHistory = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.GET_ALL_USER_CRASH_HISTORY}`, data);
            callback(response)
            dispatch(alluserGameHistory(response?.data))
            return response?.data
        } catch (e) {
            return console.error(e.message)
        }
    }

export const getSingleUserCrashHistory = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.GET_SINGLE_USER_CRASH_HISTORY}`, data);
            callback(response)
            dispatch(singleuserGameHistory(response?.data))
            return response?.data
        } catch (e) {
            return console.error(e.message)
        }
    }


export const getlossdata = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.LOSS_DATA}`, data);
            callback(response)
            dispatch(lossdata(response?.data))
            return response?.data
        } catch (e) {
            return console.error(e.message)
        }
    }

export const getgamestatus = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.GetData(`${frontUrl}/${API?.GET_GAME_STATUS}`);
            callback(response)
            dispatch(getgame(response?.data))
            return response?.data
        } catch (e) {
            return console.error(e.message)
        }
    }

// GET_GAME_STATUS